(function () {
  angular.module('MktzapApp.Controllers')
    .controller('AutomaticAnswersController', automaticAnswersController);

  automaticAnswersController.$inject = ['$rootScope', '$scope', 'NotificationService', 'AutomaticAnswersService', 'EmailService'];
  function automaticAnswersController ($rootScope, $scope, NotificationService, AutomaticAnswersService, EmailService) {
    var automaticAnswersVm = this;

    automaticAnswersVm.emails = null;
    automaticAnswersVm.emailParams = {
      channelId: null,
      clientEmail: null,
      sendByEmail: 'false'
    };

    automaticAnswersVm.closeAutomaticAnswers = function () {
      if ($rootScope.vm.show_automatic_answers) {
        $rootScope.vm.selectedCard = null;
        $rootScope.vm.cardsData = null;
        $rootScope.vm.show_automatic_answers = false;
      }
    }

    automaticAnswersVm.getCreditCards = function (contact) {
      let cpfData = $rootScope.vm.content.filter(function (elem) {
        if (elem.key == 'cpf') {
          return true;
        }

        return false;
      });

      loadEmails();
      loadCreditCards(contact, cpfData);
    }

    automaticAnswersVm.verifyEmail = function () {
      if (!automaticAnswersVm.emailParams.channelId && !automaticAnswersVm.emails) {
        NotificationService.warningHandler(null, $rootScope.labels.noEmailChannels);
        automaticAnswersVm.emailParams.sendByEmail = 'false';
      }
    }

    automaticAnswersVm.fillEmailInput = function () {
      let cardNumber = $rootScope.vm.selectedCard;

      let selectedCardData = $rootScope.vm.cardsData.filter(function (elem) {
        if (elem.contractNumber == cardNumber) {
          return true;
        }

        return false;
      });

      if (selectedCardData.length > 0) {
        automaticAnswersVm.emailParams.clientEmail = selectedCardData[0].clientEmail;
      }
    }

    function loadEmails () {
      EmailService.all({},
        function (data) {
          setEmails(data);
        },
        function (error) {
          NotificationService.warningHandler(null, 'Erro ao carregar o canal de Email');
        });
    }

    function setEmails (data) {
      if (data.length > 0) {
        if (data.length < 2) {
          automaticAnswersVm.emailParams.channelId = data[0].id;
          return;
        }

        automaticAnswersVm.emails = data;
      }
    }

    function loadCreditCards (contact, cpfData) {
      if (cpfData[0].metadata && cpfData[0].metadata.value != '') {
        AutomaticAnswersService.all({
          contact_id: contact.id,
          cpf: cpfData[0].metadata.value
        })
          .$promise
          .then(function (data) {
            if (data.success && data.cards.length > 0) {
              $rootScope.vm.cardsData = data.cards;
              $rootScope.vm.show_automatic_answers = true;

              if (data.cards.length === 1) {
                $rootScope.vm.selectedCard = $rootScope.vm.cardsData[0].contractNumber;
              }

              return;
            }

            if (!data.success && typeof data.message !== 'undefined') {
              $rootScope.vm.show_automatic_answers = false;
              NotificationService.warningHandler(null, data.message);
            }
          })
          .catch(function (data) {
            NotificationService.errorHandler(null, $rootScope.labels.creditCardsError);
          });
      } else {
        $rootScope.vm.show_automatic_answers = false;
        NotificationService.warningHandler(null, $rootScope.labels.anyCpfRegistred);
      }
    }

    automaticAnswersVm.sendAction = function (contact, action) {
      if ($rootScope.vm.selectedCard) {
        if (!validEmail()) {
          return;
        }

        getActions(contact, action)
          .$promise
          .then(function (data) {
            automaticAnswersVm.closeAutomaticAnswers();
            showSendResponseNotification(data);
          })
          .catch(function (data) {
            automaticAnswersVm.closeAutomaticAnswers();
            NotificationService.errorHandler(null, $rootScope.labels.requestError);
          });
      } else {
        NotificationService.warningHandler(null, $rootScope.labels.anySelectedCards);
      }
    }

    function validEmail () {
      if (automaticAnswersVm.emailParams.sendByEmail == 'true' &&
                (!automaticAnswersVm.emailParams.channelId ||
                    !automaticAnswersVm.emailParams.clientEmail)
      ) {
        if (!$scope.AutomaticAnswersForm.automaticEmail.$valid) {
          NotificationService.warningHandler(null, 'Email inválido');
          automaticAnswersVm.changeEmailInputColor();
          return false;
        }

        NotificationService.warningHandler(null, $rootScope.labels.fillAllInputs);
        automaticAnswersVm.changeEmailInputColor();
        return false;
      }

      return true;
    }

    automaticAnswersVm.changeEmailInputColor = function () {
      if (!$scope.AutomaticAnswersForm.automaticEmail.$valid) {
        angular.element('#automaticEmail')[0].style.border = '2px solid red';
      } else {
        angular.element('#automaticEmail')[0].style.border = '2px solid green';
      }
    }

    function getActions (contact, action) {
      if (action == 'invoiceCopy') {
        return AutomaticAnswersService.invoiceCopy({
          contact: contact,
          contractNumber: $rootScope.vm.selectedCard,
          emailParams: automaticAnswersVm.emailParams
        });
      }

      if (action == 'latestReleases') {
        return AutomaticAnswersService.latestReleases({
          contact: contact,
          contractNumber: $rootScope.vm.selectedCard
        });
      }

      if (action == 'limit') {
        return AutomaticAnswersService.limit({
          contact: contact,
          contractNumber: $rootScope.vm.selectedCard
        });
      }
    }

    function showSendResponseNotification (data) {
      if (data.success) {
        NotificationService.successHandler(null, $rootScope.labels.requestPorcessed);
        return;
      }

      if (!data.success && typeof data.message !== 'undefined') {
        NotificationService.warningHandler(null, data.message);
        return;
      }

      NotificationService.errorHandler(null, $rootScope.labels.requestError);
    }
  }
})();
